import type { ReactNode } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/Button';

type Props = {
  isOpen: boolean;
  title: string;
  isPending: boolean;
  canSubmit: boolean;
  onClose: () => void;
  onSubmit: () => void;
  children: ReactNode;
};

export default function LinkedAccountEditFieldModal({
  isOpen,
  title,
  isPending,
  canSubmit,
  onClose,
  onSubmit,
  children,
}: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="flex w-full max-w-[600px] flex-col overflow-hidden rounded border-0 p-0 shadow-layer3">
        <div className="flex shrink-0 items-center border-b border-solid border-border px-lg py-md">
          <DialogTitle className="text-heading-xs!">{title}</DialogTitle>
        </div>
        <div className="flex flex-col gap-md p-lg">{children}</div>
        <div className="flex shrink-0 items-center justify-end gap-sm border-t border-solid border-border px-lg py-md">
          <Button color="secondary" onClick={onClose} disabled={isPending}>
            キャンセル
          </Button>
          <Button color="primary" onClick={onSubmit} disabled={isPending || !canSubmit}>
            {isPending ? '保存中...' : '保存'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
